'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservePopover = function (_Component) {
    (0, _inherits3.default)(ReservePopover, _Component);

    function ReservePopover() {
        (0, _classCallCheck3.default)(this, ReservePopover);
        return (0, _possibleConstructorReturn3.default)(this, (ReservePopover.__proto__ || (0, _getPrototypeOf2.default)(ReservePopover)).apply(this, arguments));
    }

    (0, _createClass3.default)(ReservePopover, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['id', 'styles']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                styles = _props.styles;

            var reservePopover = (0, _jsx3.default)(_Popover2.default, {
                id: id,
                bsClass: styles['reserve-dispute-text'] + ' popover'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'reserve_dispute_popover_text'
            }));
            var reserveOverlay = (0, _jsx3.default)(_OverlayTrigger2.default, {
                container: this,
                trigger: 'click',
                placement: 'bottom',
                overlay: reservePopover,
                rootClose: true
            }, void 0, (0, _jsx3.default)('span', {
                className: styles.reserve
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'reserve'
            })));
            return reserveOverlay;
        }
    }]);
    return ReservePopover;
}(_react.Component);

exports.default = ReservePopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popovers/ReservePopover.js
// module id = YaZr
// module chunks = 46